// LANGUAGE
export const SET_PATH_LANG = 'setPathLanguage';
